import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "as-player-v2" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "as__max-point" }
const _hoisted_4 = { class: "as-div__country" }
const _hoisted_5 = ["src"]


const __default__ = {};

interface IProps {
  name: string;
  scores: string;
  img?: string;
  country?: string;
  mode?: string;
  _class?: string;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'PlayerTennis',
  props: {
    name: { default: "Alex Toohey" },
    scores: { default: "20" },
    img: {},
    country: {},
    mode: { default: "tennis" },
    _class: { default: "home" }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass('as-player-v2-item as-player-v2-item__' + _ctx._class)
    }, [
      _createElementVNode("div", {
        class: _normalizeClass('as-player-v2-item__img ' + _ctx._class)
      }, [
        _createElementVNode("img", {
          src: _ctx.img || _ctx.getImgUrlBySport('player', '4wyrn1tvowkq86p', true, 'basketball'),
          class: "as-player-v2-item__player"
        }, null, 8, _hoisted_2),
        (_ctx.country)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass('as-player-v2-item__country ' + _ctx._class)
            }, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.scores), 1),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("img", {
                  src: _ctx.country || _ctx.getImgUrlBySport('team', 'gy0or5jhdwxqwzv', true, 'football'),
                  class: "as__country"
                }, null, 8, _hoisted_5)
              ])
            ], 2))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(`as-player-v2-item__name as-player-v2-item__name-${_ctx._class}`)
      }, _toDisplayString(_ctx.name), 3)
    ], 2)
  ]))
}
}

})